import { marked } from 'marked'
import hljs from 'highlight.js'
import 'highlight.js/styles/github.css'
import { sanitizeHtml } from './sanitizeHtml'

let configured = false

export function configureMarked() {
  if (configured) return
  marked.setOptions({
    highlight(code, lang) {
      if (lang && hljs.getLanguage(lang)) {
        try {
          return hljs.highlight(code, { language: lang }).value
        } catch (e) {
          console.error(e)
        }
      }
      return hljs.highlightAuto(code).value
    },
    breaks: true,
    gfm: true
  })
  configured = true
}

export function renderMarkdown(content) {
  configureMarked()
  if (!content) return ''
  return sanitizeHtml(marked.parse(content))
}

/** 测评说明常用写法：行首 `--` 转为列表项 */
export function preprocessExamMarkdown(content) {
  if (!content) return ''
  return String(content)
    .replace(/\r\n/g, '\n')
    .replace(/^--\s+/gm, '- ')
}

export function renderExamMarkdown(content) {
  return renderMarkdown(preprocessExamMarkdown(content))
}
